/* ═══════════════════════════════════════════════════
   ARRS SILKS — Cart + Wishlist System
   ─────────────────────────────────────────────────── */

/* ── CART: Add + Open Drawer ─────────────────────── */
window.arrsAddToCart = function(variantId, qty, btnEl) {
  if (!variantId) return;
  qty = qty || 1;

  var btn = btnEl;
  var originalHTML = btn ? btn.innerHTML : '';
  var originalBg   = btn ? btn.style.background : '';
  if (btn) {
    btn.innerHTML  = '⏳ Adding...';
    btn.disabled   = true;
    btn.style.background = '#555';
  }

  /* Request Dawn section renders for the cart drawer + icon bubble */
  var sectionsNeeded = [];
  if (document.querySelector('cart-drawer'))       sectionsNeeded.push('cart-drawer');
  if (document.getElementById('cart-icon-bubble')) sectionsNeeded.push('cart-icon-bubble');

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({
      id:           variantId,
      quantity:     qty,
      sections:     sectionsNeeded,
      sections_url: window.location.pathname
    })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    var cartDrawer = document.querySelector('cart-drawer');

    /* ── Render updated cart drawer HTML ── */
    if (cartDrawer && data.sections && data.sections['cart-drawer']) {
      /* Use Dawn's native renderContents if available */
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        /* Manual fallback */
        var parser = new DOMParser();
        var doc    = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
        var inner  = doc.querySelector('#CartDrawer');
        if (inner) {
          var target = document.getElementById('CartDrawer');
          if (target) target.innerHTML = inner.innerHTML;
        }
        arrsOpenDrawer(cartDrawer);
      }
    } else if (cartDrawer) {
      arrsOpenDrawer(cartDrawer);
    }

    /* ── Update cart count bubble (Dawn cart-icon-bubble) ── */
    if (data.sections && data.sections['cart-icon-bubble']) {
      var bubbleDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      var newBubble = bubbleDoc.getElementById('cart-icon-bubble');
      var oldBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && oldBubble) oldBubble.outerHTML = newBubble.outerHTML;
    }

    /* ── Always update every count badge in the page (custom header, mobile bottom nav, etc.) ── */
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart) {
        if (cart && typeof cart.item_count === 'number' && window.arrsUpdateCartCount) {
          window.arrsUpdateCartCount(cart.item_count);
        }
      })
      .catch(function(){});

    /* ── Button success state ── */
    if (btn) {
      btn.innerHTML  = '✅ Added!';
      btn.style.background = '#1A5C4A';
      btn.disabled   = false;
      setTimeout(function() {
        btn.innerHTML  = originalHTML;
        btn.style.background = originalBg;
      }, 2000);
    }
  })
  .catch(function(err) {
    console.error('[ARRS] Add to cart failed:', err);
    if (btn) {
      btn.innerHTML  = '⚠️ Error — Try again';
      btn.disabled   = false;
      btn.style.background = '#c00';
      setTimeout(function() {
        btn.innerHTML  = originalHTML;
        btn.style.background = originalBg;
      }, 2500);
    }
  });
};

function arrsOpenDrawer(cartDrawer) {
  if (!cartDrawer) return;
  if (typeof cartDrawer.open === 'function') {
    cartDrawer.open();
  } else {
    /* Dawn sets aria-expanded and removes is-empty class */
    cartDrawer.setAttribute('aria-expanded', 'true');
    cartDrawer.classList.remove('is-empty');
    var inner = cartDrawer.querySelector('.drawer__inner');
    if (inner) inner.style.visibility = 'visible';
    document.body.classList.add('overflow-hidden');
  }
}

/* ── WISHLIST ──────────────────────────────────────── */
var ARRS_WL_KEY = 'arrs_wishlist_v2';

function arrsWlGet() {
  try { return JSON.parse(localStorage.getItem(ARRS_WL_KEY)) || []; } catch(e) { return []; }
}
function arrsWlSave(items) {
  try { localStorage.setItem(ARRS_WL_KEY, JSON.stringify(items)); } catch(e) {}
}

window.arrsWishlistToggle = function(productId, title, url, price, image, btnEl) {
  var items = arrsWlGet();
  var idx   = items.findIndex(function(i) { return String(i.id) === String(productId); });
  var added = idx === -1;

  if (added) {
    items.unshift({ id: productId, title: title, url: url, price: price, image: image, at: Date.now() });
  } else {
    items.splice(idx, 1);
  }

  arrsWlSave(items);
  arrsWlUpdateBtn(btnEl, added);
  arrsWlUpdateCounts();
  arrsWlToast(added ? title + ' added to wishlist' : title + ' removed from wishlist');
};

window.arrsWishlistIsAdded = function(productId) {
  return arrsWlGet().some(function(i) { return String(i.id) === String(productId); });
};

function arrsWlUpdateBtn(btn, isAdded) {
  if (!btn) return;
  var svg = btn.querySelector('svg');
  if (isAdded) {
    btn.classList.add('is-wishlisted');
    if (svg) { svg.style.fill = '#720701'; svg.style.stroke = '#720701'; }
    btn.setAttribute('aria-label', 'Remove from wishlist');
  } else {
    btn.classList.remove('is-wishlisted');
    if (svg) { svg.style.fill = 'none'; svg.style.stroke = '#720701'; }
    btn.setAttribute('aria-label', 'Add to wishlist');
  }
}

function arrsWlUpdateCounts() {
  var count = arrsWlGet().length;
  document.querySelectorAll('.arrs-wl-count').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

/* Toast notification */
function arrsWlToast(msg) {
  var t = document.getElementById('arrsToast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'arrsToast';
    t.style.cssText = [
      'position:fixed;bottom:100px;left:20px;z-index:9999',
      'background:#1E1E1E;color:#fff;padding:12px 20px',
      'border-radius:4px;font-family:Jost,sans-serif;font-size:13px',
      'box-shadow:0 4px 16px rgba(0,0,0,.3)',
      'transition:opacity .3s;opacity:0;max-width:300px;line-height:1.4'
    ].join(';');
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.style.opacity = '1';
  clearTimeout(t._timer);
  t._timer = setTimeout(function() { t.style.opacity = '0'; }, 2800);
}

/* Init: mark buttons already wishlisted */
document.addEventListener('DOMContentLoaded', function() {
  arrsWlUpdateCounts();
  document.querySelectorAll('[data-wl-id]').forEach(function(btn) {
    if (arrsWishlistIsAdded(btn.dataset.wlId)) {
      arrsWlUpdateBtn(btn, true);
    }
  });
});

/* ── Update every cart-count badge in the page ── */
window.arrsUpdateCartCount = function(count) {
  if (typeof count !== 'number') return;
  /* Custom header bubble (.arrs-cart-ct) */
  document.querySelectorAll('.arrs-cart-ct').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
  /* Mobile bottom-nav bubble */
  document.querySelectorAll('.arrs-botnav__cart-count').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
  /* Dawn-style cart-count-bubble fallback */
  document.querySelectorAll('.cart-count-bubble').forEach(function(bubble) {
    bubble.style.display = count > 0 ? '' : 'none';
    var span = bubble.querySelector('span:first-child');
    if (span) span.textContent = count;
  });
  /* Anyone listening can read this attribute / data hook */
  document.documentElement.setAttribute('data-cart-count', count);
};

/* ── Patch Dawn's section-render loop ──
   CartDrawerItems / CartItems include `cart-icon-bubble` in
   getSectionsToRender(). Dawn's updateQuantity() then does
   document.getElementById('cart-icon-bubble').querySelector(...) — when our
   custom header doesn't render that element, getElementById returns null
   and .querySelector throws. The throw aborts the .then() before reaching
   publish(PUB_SUB_EVENTS.cartUpdate), so no subscriber ever fires — which
   is why the header bubble (.arrs-cart-ct) stayed stale on drawer
   remove/quantity changes. Filter the section out when the element is missing. */
function arrsPatchCartSections(elementName) {
  if (!window.customElements) return;
  var Cls = customElements.get(elementName);
  if (!Cls || Cls.prototype._arrsPatched) return;
  var orig = Cls.prototype.getSectionsToRender;
  if (typeof orig !== 'function') return;
  Cls.prototype.getSectionsToRender = function() {
    var sections = orig.call(this);
    return sections.filter(function(s) {
      if (s && s.id === 'cart-icon-bubble' && !document.getElementById('cart-icon-bubble')) return false;
      return true;
    });
  };
  Cls.prototype._arrsPatched = true;
}
arrsPatchCartSections('cart-drawer-items');
arrsPatchCartSections('cart-items');
/* If a custom element wasn't defined yet at script parse time, retry once. */
document.addEventListener('DOMContentLoaded', function() {
  arrsPatchCartSections('cart-drawer-items');
  arrsPatchCartSections('cart-items');
});

/* ── Dawn pub-sub bridge ──
   Dawn's cart.js (used by the cart drawer) publishes 'cart-update' after
   every quantity change / line-item remove. It tries to patch
   #cart-icon-bubble — but our custom header bubble is .arrs-cart-ct, so
   the badge would otherwise stay stale. Bridge the event here. */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
    var count = event && event.cartData && event.cartData.item_count;
    if (typeof count === 'number') {
      window.arrsUpdateCartCount(count);
    } else {
      /* Fallback: re-fetch /cart.js if no item_count was passed */
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart && typeof cart.item_count === 'number') {
            window.arrsUpdateCartCount(cart.item_count);
          }
        })
        .catch(function(){});
    }
  });
}

/* ── Live cart refresh listener ──
   Any code that hits /cart/* and wants every count badge + the drawer
   to update without a page reload should dispatch this event. */
document.addEventListener('cart:refresh', function() {
  /* 1) Always update the custom header count via /cart.js — works even when
        the theme does not include the Dawn cart-icon-bubble section. */
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (cart && typeof cart.item_count === 'number') {
        window.arrsUpdateCartCount(cart.item_count);
      }
    })
    .catch(function(){});

  /* 2) Refresh Dawn sections (cart-drawer + cart-icon-bubble if present) */
  var sectionsNeeded = [];
  if (document.querySelector('cart-drawer'))       sectionsNeeded.push('cart-drawer');
  if (document.getElementById('cart-icon-bubble')) sectionsNeeded.push('cart-icon-bubble');
  if (!sectionsNeeded.length) return;

  fetch('/?sections=' + sectionsNeeded.join(','))
    .then(function(r) { return r.json(); })
    .then(function(sections) {
      if (sections['cart-icon-bubble']) {
        var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var newBubble = bubbleDoc.getElementById('cart-icon-bubble');
        var oldBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.outerHTML = newBubble.outerHTML;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && sections['cart-drawer']) {
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: sections });
        } else {
          var parser = new DOMParser();
          var doc    = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var inner  = doc.querySelector('#CartDrawer');
          var target = document.getElementById('CartDrawer');
          if (inner && target) target.innerHTML = inner.innerHTML;
        }
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      }
    })
    .catch(function(){});
});

/* On initial page load — make sure the count badge is hidden when zero */
document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (cart && typeof cart.item_count === 'number') {
        window.arrsUpdateCartCount(cart.item_count);
      }
    })
    .catch(function(){});
});
